import { RelatedTypes } from '../constants';
import { CaretDownIcon } from 'assets/icons';
import { getRelatedItemsStatus } from '../util';
import { If } from 'components';
import { TransactionRelatedDetails as TransactionRelatedDetailsType } from '../receipt.model';
import { parseAndFormatMoneyString } from 'utils/amountUtils';

const TransactionRelatedDetails = ({ data, handleClick }) => {
  const handleRelatedItemClick = (item: TransactionRelatedDetailsType) => {
    if (item?.hasPermission) {
      handleClick(item?.id, item?.type);
    }
  };

  return (
    <div className="flex flex-col text-sbase">
      <div className="font-semibold text-primaryText">Related</div>
      <ul className="flex flex-col gap-4 divide-y">
        {data?.map((item, index) => {
          const relatedType = RelatedTypes?.[item.type];
          const Icon = relatedType?.icon;
          return (
            <li
              onClick={() => handleRelatedItemClick(item)}
              key={index + item.id}
              className={`flex items-center pt-4 ${item?.hasPermission ? 'cursor-pointer' : ''}`}>
              <div className="mr-3 shrink-0 self-baseline">
                {Icon && <Icon className={relatedType?.iconClass ? relatedType.iconClass : ''} />}
              </div>
              <div className="flex w-5/12 flex-col gap-1">
                <div className="font-semibold text-tertiaryText">
                  {relatedType?.text} {item?.number ? item.number : item.id}
                </div>
                <If condition={Boolean(item.reason)}>
                  <div className="text-[15px] text-primaryText">Reason: {item.reason}</div>
                </If>
                <div className="text-[13px] text-accentText">{item.date}</div>
              </div>
              <div className="ml-auto mr-1 flex w-5/12 flex-col text-end">
                <div className="text-[15px] font-bold text-primaryText">{parseAndFormatMoneyString(item.amount)}</div>
                <div>{getRelatedItemsStatus(item.status, item?.type)}</div>
              </div>
              <div className={item?.hasPermission ? '' : 'hidden'}>
                <CaretDownIcon className="-rotate-90" />
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
};
export default TransactionRelatedDetails;
